(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-footer"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
    var stickyBtn = document.querySelector('.sticky-btn');
    var stickyAddToCartBtn = document.querySelector('#StickyAddToCart');
    stickyBtn?.addEventListener?.('click', function() {
      if (stickyAddToCartBtn) { stickyAddToCartBtn.click(); }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
